import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ActionDataResult } from '../../../../shared/models/core/ActionDataResult';
import { MailingRegister } from '../../../../shared/models/mailings/mailing-register';
import { AppService } from '../../../../app.service';
import { FilterStorage } from '../../../../shared/components/filter-storage/filter-storage'; 
import { ListPageBase } from '../../../../shared/components/list-page-base/list-page-base';
import { MailingGroupsService } from '../../../../shared/services/mailing-groups.service';
import { MailingRegistersService } from '../../../../shared/services/mailing-registers.service';

@Component({
	selector: 'settings-mailing-registers',
	templateUrl: './list.page.html',
	styleUrls: ['./list.page.scss']
})
export class MailingRegistersListPage extends ListPageBase {

	public mailingRegisters: ActionDataResult<MailingRegister[]>;

	constructor(
		appService: AppService,
		router: Router,
		filterStorage: FilterStorage,
		private mailingRegistersService: MailingRegistersService,
		) {
		super(appService, router, filterStorage, mailingRegistersService);
		this.appService.pageTitle = "Журнал рассылок";
	}

	loadData(): void {
		super.loadData();

		this.mailingRegistersService.list(this.state).subscribe(data => {
			this.loading = false;
			return this.mailingRegisters = data;
		});
	}

	public cellClick({ dataItem }: any): void {
		this.router.navigate(['/settings/mailing-register', dataItem.mailingRegisterId]);
	}
}